import React, { useEffect, useState } from 'react';

type Props = {
  joinUrl: string;
  title?: string;
  password?: string;
  onLeave: () => void;
};

/** Embedded Zoom web client via join URL. */
const ZoomMeetingEmbed: React.FC<Props> = ({ joinUrl, title, password, onLeave }) => {
  const [seconds, setSeconds] = useState(0);
  const src = password
    ? `${joinUrl}${joinUrl.includes('?') ? '&' : '?'}pwd=${encodeURIComponent(password)}`
    : joinUrl;

  useEffect(() => {
    const id = window.setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => window.clearInterval(id);
  }, []);

  const timer = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;

  return (
    <div className="meet-embed">
      <div className="meet-embed-chrome">
        <div>
          <span className="meet-live-dot" aria-hidden="true" />
          Live · {title || 'Lesson'}
        </div>
        <span className="meet-timer">{timer}</span>
      </div>
      <div className="zoom-embed-frame-wrap">
        <iframe
          title="Zoom lesson"
          src={src}
          className="zoom-embed-frame"
          allow="camera; microphone; fullscreen; display-capture; autoplay"
        />
      </div>
      <div className="meet-toolbar">
        <button type="button" className="meet-tool leave" onClick={onLeave}>
          Leave meeting
        </button>
      </div>
    </div>
  );
};

export default ZoomMeetingEmbed;
